import React from 'react';
import PropTypes from 'prop-types';
import Link from '../Global/Link';
import ImageHandler from '../../utils/ImageHandler';
import Markdown from '../Richtext/Markdown';

// ====

const CardGame = (props) => {
  const { title, image, copy, link, mode, animate } = props;

  // ====

  return (
    <div
      className={`brand-col ${
        mode === 'slim' ? 'col-6 col-md-4' : 'col brand-col-auto'
      }`}
      data-sal={animate === 'normal' ? 'zoom-in' : false}
      data-sal-duration={animate === 'normal' ? '500' : false}
      data-sal-delay={animate === 'normal' ? 0 : false}
      data-sal-easing={animate === 'normal' ? 'easeOutSine' : false}
    >
      <div
        className={`card h-100 brand-card-image-top ${
          animate === 'onReveal' && 'brand-animate-onReveal'
        }`}
      >
        <div className="card-header border-0 p-0">
          <div
            className="brand-card-image brand-background-cover"
            style={{
              backgroundImage: `url(${ImageHandler(image, '960x540')})`,
            }}
          />
        </div>
        {mode === 'regular' && (
          <div className="card-body">
            {title && <h4 className="brand-font-caps">{title}</h4>}
            {copy && <Markdown>{copy}</Markdown>}
          </div>
        )}
        <Link stretched to={`/our-games/${link.replace('games/', '')}/`} />
      </div>
    </div>
  );
};

export default CardGame;

// ====

CardGame.propTypes = {
  title: PropTypes.string,
  image: PropTypes.string,
  copy: PropTypes.string,
  link: PropTypes.string,
  mode: PropTypes.string,
  animate: PropTypes.string,
};

CardGame.defaultProps = {
  title: '',
  image: '',
  copy: '',
  link: '',
  mode: 'regular',
  animate: 'normal',
};
